import React from "react";
import ReactDOM from "react-dom";
import { OosActionButtons } from "./oos-action-buttons";

let oosActionButtonsWrappers;

export const unmount = () => {
  if (!oosActionButtonsWrappers) {
    return;
  }
  [].forEach.call(oosActionButtonsWrappers, (oosActionButtonsWrapper) => {
    ReactDOM.unmountComponentAtNode(oosActionButtonsWrapper);
  });
};

export default () => {
  oosActionButtonsWrappers = document.querySelectorAll(".oos-action-buttons");
  if (!oosActionButtonsWrappers) {
    return;
  }

  [].forEach.call(oosActionButtonsWrappers, (oosActionButtonsWrapper) => {
    ReactDOM.render(
      <OosActionButtons
        storeStockVisible={oosActionButtonsWrapper.getAttribute("data-store-stock")}
        emailMeVisible={oosActionButtonsWrapper.getAttribute("data-email-me")}
      />,
      oosActionButtonsWrapper
    )
  });

  return null;
}
